import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import CONSTANTS from '../../_constants/constants';
import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';
import { UtilService } from '../../_shared/services/util.service';
import { ChartAccount } from './chart-account.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_name?: any;
  by_status?: any;
  by_chart_account_types?: any;
  by_currency_id?: any;
  by_global_filter?: any;
}

@Injectable({
  providedIn: 'root',
})
export class ChartAccountService {
  private apiUrl = environment.apiEndpoint + 'account_catalogs';

  constructor(private http: HttpClient, private utilService: UtilService) {}

  getFilterCriteria() {
    let defaultParams: ExtendedDefaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'code',
      company_id: null,
    };

    return defaultParams;
  }

  getChartAccounts(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    let queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        return {
          data: resp['data'],
          meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
        };
      })
    );
  }

  getChartAccount(id: string, params = null): Observable<ChartAccount> {
    let queryParams = new HttpParams({ fromObject: params }); // = {}
    // When we need to catch global error and get in the service
    return this.http
      .get<ChartAccount>(`${this.apiUrl}/${id}`, {
        params: queryParams,
      })
  }

  // Save / Update
  saveChartAccount(chartAccountId: string, chartAccount: ChartAccount, language = ''): Observable<ChartAccount> {
    const body = {
      account_catalog: chartAccount,
      lang: language || CONSTANTS.DEFAULT_CONTENT_LANGUAGE,
    };

    if (!chartAccountId) {
      return this.http.post<ChartAccount>(`${this.apiUrl}`, body);
    } else {
      return this.http.put<ChartAccount>(`${this.apiUrl}/${chartAccountId}`, body);
    }
  }
}
